"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagHR = function FlagHR(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06v82.39H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "156.37",
    y: "92.8",
    width: "19.77",
    height: "22.6",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "195.91",
    y: "92.8",
    width: "19.78",
    height: "22.6",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "176.14",
    y: "115.4",
    width: "19.77",
    height: "22.6",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "235.46",
    y: "92.8",
    width: "19.77",
    height: "22.6",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "215.69",
    y: "115.4",
    width: "19.77",
    height: "22.6",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "176.14",
    y: "92.8",
    width: "19.77",
    height: "22.6",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "215.69",
    y: "92.8",
    width: "19.77",
    height: "22.6",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "156.37",
    y: "115.4",
    width: "19.77",
    height: "22.6",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "195.91",
    y: "115.4",
    width: "19.78",
    height: "22.6",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "235.46",
    y: "115.4",
    width: "19.77",
    height: "22.6",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "195.91",
    y: "138",
    width: "19.78",
    height: "22.6",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "176.14",
    y: "160.6",
    width: "19.77",
    height: "22.6",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "215.69",
    y: "160.6",
    width: "19.77",
    height: "22.6",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "176.14",
    y: "138",
    width: "19.77",
    height: "22.6",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "215.69",
    y: "138",
    width: "19.77",
    height: "22.6",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "195.91",
    y: "160.6",
    width: "19.78",
    height: "22.6",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.23-30.19V33.37a49.44,49.44,0,0,1-98.87,0V-30.19H61.23m3.54-3.53H-41.17V33.37a53,53,0,0,0,105.94,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17.86,37.6V15H-37.63V33.37c0,1.43.09,2.83.21,4.23Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61,37.6H41.46V60.2H53.28A49,49,0,0,0,61,37.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-29.68,60.2h11.82V37.6H-37.42a49,49,0,0,0,7.74,22.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M41.46,37.6H61c.12-1.4.21-2.8.21-4.24V15H41.46Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17.86,72.84V60.2H-29.68A49.39,49.39,0,0,0-17.86,72.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M53.28,60.2H41.46V72.84A49.39,49.39,0,0,0,53.28,60.2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17.86,72.84a49,49,0,0,0,19.77,9V60.2H-17.86Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.69,81.81a49.09,49.09,0,0,0,19.77-9V60.2H21.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.69,60.2H1.91V81.81a49.9,49.9,0,0,0,19.78,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-24-67.59q-6.46-1-13.2-1.42-5.2,4.29-9.91,8.92l9.45,22.84a130.25,130.25,0,0,1,19.4-6.3q-2.86-12-5.74-24Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.8-71.34c-3.86-2-7.87-3.76-12-5.41-4.13,1.65-8.14,3.46-12,5.41Q.76-59,1.73-46.7a130.2,130.2,0,0,1,20.14,0q1-12.31,1.93-24.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M70.69-60.09Q66-64.72,60.77-69q-6.72.42-13.19,1.42-2.86,12-5.74,24a130.13,130.13,0,0,1,19.39,6.3l9.46-22.84Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.2-71.34c-4.12-1.33-8.37-2.49-12.72-3.47Q-18.68-71.4-24-67.59q2.86,12,5.75,24a129.93,129.93,0,0,1,20-3.15Q.76-59-.2-71.34Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M47.58-67.59c-3.53-2.54-7.23-5-11.06-7.22-4.35,1-8.59,2.15-12.72,3.47Q22.84-59,21.87-46.7a130.45,130.45,0,0,1,20,3.15q2.86-12,5.74-24Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.57-61.48A144,144,0,0,0-21.69-58c-.38-1.6-.76-3.21-1.15-4.81a150.19,150.19,0,0,1,23-3.63l.39,4.93Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.34-51.62a134.21,134.21,0,0,0-20.73,3.26c-.38-1.6-.76-3.2-1.15-4.8A137.85,137.85,0,0,1,1-56.55l.39,4.93Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35.26-50c-1.73-.31-3.45-.58-5.19-.82a5.29,5.29,0,0,1-4.72-5.53c.25-2.72,3-4.69,6.07-4.26q2.79.38,5.57.87c3.09.55,5.08,3.27,4.48,5.93A5.3,5.3,0,0,1,35.26-50Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M63.12-41.82A134.79,134.79,0,0,0,43-48.36c.39-1.6.77-3.2,1.16-4.8A139.25,139.25,0,0,1,65-46.39c-.63,1.52-1.26,3-1.9,4.57Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.36-56.65a4.12,4.12,0,0,1-5.28,2.11,4.11,4.11,0,0,1-3-4.8c.56-2,2.95-3,5.31-2.25s3.69,3,3,4.94Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-29.46-59.34a4.11,4.11,0,0,1-3,4.8,4.12,4.12,0,0,1-5.28-2.11c-.7-1.93.63-4.17,3-4.94s4.75.28,5.31,2.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.67-62.58a3.23,3.23,0,0,1-3.29,3,3.23,3.23,0,0,1-3.47-2.82,3.17,3.17,0,0,1,3.28-3.11,3.17,3.17,0,0,1,3.48,2.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.69-62.37a3.23,3.23,0,0,1-3.47,2.82,3.22,3.22,0,0,1-3.29-3,3.16,3.16,0,0,1,3.47-2.9,3.17,3.17,0,0,1,3.29,3.11Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15-55A3.11,3.11,0,0,1,11.8-52,3.12,3.12,0,0,1,8.59-55a3.07,3.07,0,0,1,3.21-3A3.06,3.06,0,0,1,15-55Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagHR;
exports["default"] = _default;